module.exports = __webpack_public_path__ + "static/media/tejinder-singh.74af6dbe.jpg";